import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Box, Tooltip, Typography } from "@mui/material";
import { ChatMessageTime } from "@/features/chat/ui/ChatMessageTime";

type ChatUserMessageProps = {
  content: string;
  /** When the question was asked, shown under it. */
  askedAt?: number;
  /** Who asked, shown on hovering the avatar. */
  askerName?: string | null;
};

export function ChatUserMessage({ content, askedAt, askerName }: ChatUserMessageProps) {
  const avatar = (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "var(--theme-surface-hover)",
        color: "var(--theme-text-secondary)",
        flexShrink: 0,
      }}
      {...(askerName ? { role: "img", "aria-label": askerName } : { "aria-hidden": true })}
    >
      <PersonOutlineIcon sx={{ fontSize: 18 }} />
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            borderRadius: 2,
            px: 2,
            py: 1.25,
            maxWidth: "72%",
            bgcolor: "var(--theme-primary)",
            color: "var(--theme-text-on-primary)",
          }}
        >
          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
            {content}
          </Typography>
        </Box>
        {askedAt !== undefined ? <ChatMessageTime at={askedAt} /> : null}
      </Box>
      {askerName ? <Tooltip title={askerName}>{avatar}</Tooltip> : avatar}
    </Box>
  );
}
